<template>
  <v-row style="width: 25rem;">
    <img
      :src="imgicon"
      class="img-icon px-2" />
    <h3 class="header-name">
      {{ $t(headername) }}
      <!-- {{ $route.meta.name }} -->
    </h3>
  </v-row>
</template>

<script>
export default {
  name: 'HeaderTitle',
  props: {
    headername: {
      type: String,
      default: null
    },
    imgicon: {
      type: String,
      default: null
    },
    index: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Prompt&display=swap');

.header-name{
font-family: 'Prompt';
font-style: normal;
font-weight: 400;
font-size: 24px;
line-height: 36px;
color: #FFFFFF;
}
</style>
